// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","main-color":"var(--main-color)","tooltip":"_1UplDts","arrow":"_1ETMBeo","extra_component":"huVSAOl"};